// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline-element .publication-date{margin:0}.timeline-element .timeline-content img{max-width:35%}@media (max-width: 767.98px){.timeline-element .timeline-content iframe{width:90%}}\n", ""]);
// Exports
module.exports = exports;
